import gsap from 'gsap';

/**
 * Filter actions for the team nodetype.
 */
export const initTeamFilter = () => {
    document.querySelectorAll('.c-team').forEach(team => {
        const grid = team.querySelector('.c-team-grid');
        const categoriesSelect = team.querySelector('.categories-select');
        const categoriesButtons = team.querySelector('.categories-buttons');
        const locationsSelect = team.querySelector('.locations-select');
        const locationsButtons = team.querySelector('.locations-buttons');

        if (!grid || !categoriesSelect || !categoriesButtons || !locationsSelect || !locationsButtons) return;

        /**
         * Show previous separator element.
         *
         * @param element
         */
        const findPreviousSeparator = element => {
            let prev = element.previousElementSibling;
            while (prev) {
                if (prev.classList.contains('purview-separator')) {
                    prev.classList.remove('!hidden');
                    return;
                }
                prev = prev.previousElementSibling;
            }
            return null;
        }

        /**
         * Filter by target. Trigger is either "category" or "location".
         *
         * @param target
         * @param trigger
         */
        const filter = (target, trigger) => {
            let hitCount = 0;

            [...grid.children].forEach(element => {
                const purview = element.dataset.purview ? element.dataset.purview === (trigger === 'category' ? target : categoriesSelect.value) : false;
                const fields = element.dataset.fields ? element.dataset.fields.split(',').includes((trigger === 'category' ? target : categoriesSelect.value)) : false;
                const cb = element.classList.contains('colorbox-with-link') && (trigger === 'category' ? target : categoriesSelect.value) === '_cb';
                const location = element.dataset.location ? element.dataset.location.includes((trigger === 'location' ? target : locationsSelect.value)) : false;

                const currentLocationFilterValue = (trigger === 'location' ? target : locationsSelect.value);
                const currentCategoryFilterValue = (trigger === 'category' ? target : categoriesSelect.value);

                gsap.to(grid, { duration: 0.5, opacity: 0 });

                setTimeout(() => {
                    // Hide element if
                    // target or opposite filter value is not "all",
                    // the purview does not equal the current category selection,
                    // the fields don't include the current category selection,
                    // it's a color box but the current category selection is not '_cb' AND
                    // the location does not equal the current location selection.
                    if ((currentLocationFilterValue === 'all' && currentCategoryFilterValue === 'all') || ((purview || fields || cb || currentCategoryFilterValue === 'all') && (location || currentLocationFilterValue === 'all'))) {
                        element.classList.remove('!hidden');
                        findPreviousSeparator(element);
                        hitCount++;
                    } else {
                        element.classList.add('!hidden');
                    }

                    gsap.to(grid, { duration: 1, opacity: 1 });
                }, 500);

                // Set target as appropriate selection value
                if (trigger === 'category') {
                    categoriesSelect.value = target;
                } else {
                    locationsSelect.value = target;
                }

                setTimeout(() => {
                    // If no elements are visible, show the "no results" message.
                    const noResults = team.querySelector('.c-team-no-results');

                    if (hitCount > 0) {
                        noResults.classList.add('!hidden');
                    } else {
                        noResults.classList.remove('!hidden');
                    }
                }, 700);
            });

            // Add the "active" class to the button with only the target value.
            if (trigger === 'category') {
                [...categoriesButtons.children].forEach(button => {
                    if (!button.dataset.target) return;
                    button.classList.toggle('active', button.dataset.target === target);
                });
            }
            if (trigger === 'location') {
                [...locationsButtons.children].forEach(button => {
                    if (!button.dataset.target) return;
                    button.classList.toggle('active', button.dataset.target === target);
                });
            }
        };

        categoriesSelect.addEventListener('change', () => filter(categoriesSelect.value, 'category'));

        [...categoriesButtons.children].forEach(button => {
            if (!button.dataset.target) return;

            button.addEventListener('click', () => {
                if (button.classList.contains('active')) return;
                filter(button.dataset.target, 'category');
            });
        });

        locationsSelect.addEventListener('change', () => filter(locationsSelect.value, 'location'));

        [...locationsButtons.children].forEach(button => {
            if (!button.dataset.target) return;

            button.addEventListener('click', () => {
                if (button.classList.contains('active')) return;
                filter(button.dataset.target, 'location');
            });
        });
    });
};
